import React from "react";
import "../css/costCards.scss";
import {
  calcJobsMaterials,
  calcJobsTotalCost,
  calcJobMaterials,
  calcJobTotal,
  calcJobSetPricesAndLabour,
  calcJobsSetPricesAndLabour,
  calcSubcontractorProfit,
  calcVat,
} from "../helperFunctions/calculationFunctions";

export const LabourCosts = ({ isSingle = true, jobDescription = null, jobDescriptions = [], vat }) => {
  let labourCost = 0.0;

  //   console.log("IN LABOUR", jobDescriptions);
  //If cost card is part of a totals card, it is being used on a primary - so use
  //all job descriptions. If it is a single card, a job description will be
  //provided, so use that to calculate a single job's labour cost.
  let singleStyle;
  if (isSingle) {
    singleStyle = "single";
    labourCost = calcJobSetPricesAndLabour(jobDescription, vat);
    //labourCost = calcJobLabour(jobDescription);
  } else {
    singleStyle = "";
    labourCost = calcJobsSetPricesAndLabour(jobDescriptions, vat);
    //labourCost = calcJobsLabour(jobDescriptions);
  }

  const [vatCost, inc] = calcVat(labourCost, vat);

  return (
    <div className={`costCard ${singleStyle}`}>
      <p className="costLabel">Labour</p>
      <div className="costList">
        <div className="costLine">
          <p className="costLineLabel">exc:</p>
          <p className="costLinePrice">£{labourCost}</p>
        </div>
        <div className="costLine">
          <p className="costLineLabel">vat:</p>
          <p className="costLinePrice">£{vatCost}</p>
        </div>
        <div className="costLine">
          <p className="costLineLabel">inc:</p>
          <p className="costLinePrice">£{inc}</p>
        </div>
      </div>
    </div>
  );
};

export const MaterialsCosts = ({
  isSingle = true,
  jobDescription = null,
  jobDescriptions = [],
  vat = false,
}) => {
  let materialsCost = 0.0;
  let materialsBaseCost = 0.0;
  let materialsDifferenceCost = 0.0;

  //   console.log("IN MATERIALS", jobDescriptions);
  let singleStyle;
  //If cost card is part of a totals card, it is being used on a primary - so use
  //all job descriptions. If it is a single card, a job description will be
  //provided, so use that to calculate a single job's labour cost.
  if (isSingle) {
    singleStyle = "single";
    [materialsCost, materialsBaseCost, materialsDifferenceCost] = calcJobMaterials(jobDescription);
  } else {
    singleStyle = "";
    [materialsCost, materialsBaseCost, materialsDifferenceCost] = calcJobsMaterials(jobDescriptions);
  }

  const [vatCost, inc] = calcVat(materialsCost, vat);

  return (
    <div className={`costCard ${singleStyle}`}>
      <p className="costLabel">Materials</p>
      <div className="costList">
        <div className="costLine">
          <p className="costLineLabel">exc:</p>
          {/* <p className="costLinePrice">£{materialsBaseCost}</p> */}
          <p className="costLinePrice">£{materialsCost}</p>
        </div>
        {/* <div className="costLine"> */}
        {/* <p className="costLineLabel">markup:</p> */}
        {/* <p className="costLinePrice">£{materialsDifferenceCost}</p> */}
        {/* </div> */}
        <div className="costLine">
          <p className="costLineLabel">vat:</p>
          <p className="costLinePrice">£{vatCost}</p>
        </div>
        <div className="costLine">
          <p className="costLineLabel">inc:</p>
          {/* <p className="costLinePrice">£{materialsCost}</p> */}
          <p className="costLinePrice">£{inc}</p>
        </div>
      </div>
    </div>
  );
};

export const SubcontractorProfit = ({ totalCost }) => {
  let [subcontractorProfit, subcontractorFee] = calcSubcontractorProfit(totalCost);
  return (
    <div className="costCard subcontractor">
      <p className="costLabel subcontractor">Subcontracted</p>
      <div className="costList">
        <div className="costLine">
          <p className="costLineLabel">fee:</p>
          <p className="costLinePrice">£{subcontractorFee}</p>
        </div>
        <div className="costLine">
          <p className="costLineLabel">25%:</p>
          <p className="costLinePrice">£{subcontractorProfit}</p>
        </div>
      </div>
    </div>
  );
};

export const LabourAndMaterialsCosts = ({
  isSingle = true,
  jobDescription = null,
  jobDescriptions = [],
  timesheet = null,
  vat = false,
}) => {
  let totalCost = 0.0;
  let subcontractorProfit = 0.0;
  let subcontracted = timesheet?.subcontracted;

  //   console.log("IN LABOUR AND MATERIALS", jobDescriptions);

  //If cost card is part of a totals card, it is being used on a primary - so use
  //all job descriptions. If it is a single card, a job description will be
  //provided, so use that to calculate a single job's labour cost.
  if (isSingle) {
    totalCost = calcJobTotal(jobDescription, vat);
  } else {
    totalCost = calcJobsTotalCost(jobDescriptions, vat)[4];
  }

  const [vatCost, inc] = calcVat(totalCost, vat);

  return (
    <>
      {" "}
      <div className="costCard">
        <p className="costLabel">Total</p>
        <div className="costList">
          <div className="costLine">
            <p className="costLineLabel">exc:</p>
            {/* <p className="costLinePrice">£{totalCost}</p> */}
            <p className="costLinePrice">£{totalCost}</p>
          </div>
          <div className="costLine">
            <p className="costLineLabel">vat:</p>
            {/* <p className="costLinePrice">£0.00</p> */}
            <p className="costLinePrice">£{vatCost}</p>
          </div>
          <div className="costLine">
            <p className="costLineLabel">inc:</p>
            {/* <p className="costLinePrice">£{totalCost}</p> */}
            <p className="costLinePrice">£{inc}</p>
          </div>
        </div>
      </div>
      {subcontracted && <SubcontractorProfit totalCost={totalCost} />}{" "}
    </>
  );
};

export const CombinedCosts = ({ jobDescriptions = [], timesheet, vat = false }) => {
  //   let labourCost = calcJobsLabour(jobDescriptions);
  //   let materialsCost = calcJobsMaterials(jobDescriptions);
  //   let totalCost = calcJobsTotalCost(jobDescriptions);
  /* <p>vat: Materials: {calcMaterialsvat:(calcJobsMaterials(jds))[0]}</p>
      <p>TOTAL Materials: {calcMaterialsvat:(calcJobsMaterials(jds))[1]}</p> */

  return (
    <div className="allCostsCard">
      <LabourCosts isSingle={false} jobDescriptions={jobDescriptions} vat={vat} />
      <MaterialsCosts isSingle={false} jobDescriptions={jobDescriptions} vat={vat} />
      <LabourAndMaterialsCosts
        isSingle={false}
        jobDescriptions={jobDescriptions}
        timesheet={timesheet}
        vat={vat}
      />
    </div>
  );
};

// export default LabourCosts;
